import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    capitalDepositDescription:
      'You have already initiated the formalities to create your company',
    capitalDepositTitle: 'Deposit your capital',
    companyCreationSectionHeader: 'I don’t have a company yet',
    companyUnderRegistrationSectionHeader: 'My company is under registration',
    createCompanyDescription: 'SASU, EURL, SARL, SAS',
    createCompanyTitle: 'Create a company',
    headerDescription: 'Which of the following best describes your situation?',
    onlyOneEI: 'You cannot have more than one micro-entreprise',
    openProAccountDescription: 'I already have a SIRET',
    openProAccountTitle: 'Open an account for my company',
    proAccountSectionHeader: 'My company is already registered',
    shineStartDescription: 'Becoming an auto-entrepreneur',
    shineStartTitle: 'Create a micro-entreprise',
    title: 'I want to…',
  },
  fr: {
    capitalDepositDescription:
      'Vous avez déjà commencé les démarches pour créer votre société',
    capitalDepositTitle: 'Déposer votre capital',
    companyCreationSectionHeader: 'Je n’ai pas encore d’entreprise',
    companyUnderRegistrationSectionHeader:
      'Mon entreprise est en cours d’immatriculation',
    createCompanyDescription: 'SASU, EURL, SARL, SAS',
    createCompanyTitle: 'Créer une entreprise ',
    headerDescription:
      'Pour commencer, dites-nous comment nous pouvons vous aider\u00A0:',
    onlyOneEI: 'Vous ne pouvez pas avoir plus d’une micro-entreprise',
    openProAccountDescription: 'J’ai déjà mon numéro de SIRET',
    openProAccountTitle: 'Ouvrir un compte professionnel',
    proAccountSectionHeader: 'Mon entreprise est déjà créée',
    shineStartDescription: 'Devenir auto-entrepreneur',
    shineStartTitle: 'Créer une micro-entreprise',
    title: 'Je souhaite…',
  },
});

export default locales;
